import { useCallback, useEffect } from 'react';
import { useTopBarCustomEventListener } from '@frontend/shared';
import { useTopBarShallowStore, type TopBarSelectableIcons } from '../store/use-top-bar-store';

export const useTopBarSelection = () => {
  const {
    selectedIcon,
    isActionMobileOpen,
    setSelectedIcon,
    setActionMobileOpen,
    setSchedulePulseOpen,
    setQuickFillOpen,
  } = useTopBarShallowStore(
    'selectedIcon',
    'isActionMobileOpen',
    'setSelectedIcon',
    'setActionMobileOpen',
    'setSchedulePulseOpen',
    'setQuickFillOpen'
  );

  // respond to external event to open certain trays
  useTopBarCustomEventListener('set-selected-top-bar-tray', ({ icon, mouseEvent }) => {
    mouseEvent?.stopPropagation?.();
    if (icon === 'schedulePulse' || icon === 'quickfill') {
      setSelectedIcon(icon as TopBarSelectableIcons);
      if (icon === 'schedulePulse') {
        setSchedulePulseOpen(true);
      } else if (icon === 'quickfill') {
        setQuickFillOpen(true);
      }
    }
  });

  // action menu open state synchronization
  useEffect(() => {
    if (isActionMobileOpen && selectedIcon !== 'actions') setSelectedIcon('actions');
    else if (!isActionMobileOpen && selectedIcon === 'actions') setSelectedIcon('');
  }, [isActionMobileOpen, selectedIcon, setSelectedIcon]);

  const closeAll = useCallback(() => {
    setSelectedIcon('');
  }, [setSelectedIcon]);

  return {
    isActionMobileOpen,
    setActionMobileOpen,
    closeAll,
  };
};
